var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intensive"},[_c('van-image',{attrs:{"width":"100%","height":"951px","src":_vm.getImgUrl('publicMobile/intensive/bg.png')}}),_c('div',{staticClass:"bottom-btn",on:{"click":_vm.go}},[_vm._v("立即集约")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }